import React, { useState } from 'react';
import Slider from '../slider/slider';
import surveyUtils from '../../utils/survey';

const SurveyFeed = ({ surveyData }) => {
  const [collapsed, setCollapsed] = useState(true);
  const [status, setStatus] = useState(surveyData.status || 'INACTIVA');
  const [error, setError] = useState(null);

  const toggleCollapse = () => setCollapsed((prev) => !prev);

  const handleStatusToggle = async () => {
    const newStatus = status === 'ACTIVA' ? 'INACTIVA' : 'ACTIVA';
    try {
      const res = await surveyUtils.updateSurveyStatus(surveyData._id, newStatus);
      if (res && res.success) {
        setStatus(newStatus);
        setError(null);
      } else {
        setError('No se pudo actualizar el estado.');
      }
    } catch (e) {
      setError('No se pudo actualizar el estado.');
    }
  };

  const handleDelete = async () => {
    const confirm = window.confirm('¿Está seguro que desea eliminar la encuesta?');
    if (!confirm) return;
    try {
      const res = await surveyUtils.deleteSurvey(surveyData._id);
      if (res && res.success) {
        window.location.reload();
      } else {
        setError('No se pudo eliminar la encuesta.');
      }
    } catch (e) {
      setError('No se pudo eliminar la encuesta.');
    }
  };

  return (
    <div className="card card-custom-history" key={surveyData._id}>
      <div className="card-header card-header-history" id={`heading-${surveyData._id}`}>
        <h5 className="mb-0">
          <button
            className="btn btn-width-100"
            data-toggle="collapse"
            data-target={`#collapse-${surveyData._id}`}
            aria-expanded={!collapsed}
            aria-controls={`collapse-${surveyData._id}`}
            onClick={toggleCollapse}
            type="button"
          >
            <table className="table table-custom-history">
              <tbody>
                <tr className="media media-custom">
                  <td className="media-left media-left-custom">
                    <span>
                      <span className={`badge badge-${status === 'ACTIVA' ? 'primary' : 'secondary'}`}>
                        {status}
                      </span>
                    </span>
                  </td>
                  <td className="media-body media-body-custom">
                    <h5 className="media-heading font-yellow text-bold hidden-xs">
                      Encuesta #{surveyData.surveyNumber}
                    </h5>
                    <span>
                      <strong>Desde: </strong>
                      {surveyData.dateFrom
                        ? new Date(surveyData.dateFrom).toLocaleDateString('es-AR')
                        : 'N/A'}
                    </span>
                    <br />
                    <span>
                      <strong>Hasta: </strong>
                      {surveyData.dateTo
                        ? new Date(surveyData.dateTo).toLocaleDateString('es-AR')
                        : 'N/A'}
                    </span>
                    <br />
                    <span>
                      <strong>Descripción: </strong>
                      {surveyData.description}
                    </span>
                  </td>
                </tr>
              </tbody>
            </table>
          </button>
        </h5>
      </div>
      <div
        id={`collapse-${surveyData._id}`}
        className={`collapse collapse-custom${!collapsed ? ' show' : ''}`}
        aria-labelledby={`heading-${surveyData._id}`}
        data-parent="#accordion"
      >
        <div className="card-body">
          <Slider
            title="Activada"
            checked={status === 'ACTIVA'}
            setChecked={handleStatusToggle}
          />
          <div className="mb-2">
            <strong>Estado:</strong> {status}
          </div>
          {surveyData.url && (
            <div className="mb-2">
              <strong>URL:</strong>{' '}
              <a href={surveyData.url} target="_blank" rel="noopener noreferrer">
                Click para ir a Encuesta en Google Drive
              </a>
            </div>
          )}
          <div className="mb-2">
            <strong>Respuestas:</strong> {surveyData.responsesIds ? surveyData.responsesIds.length : 0}
          </div>
          <button className="btn btn-dark" onClick={handleDelete}>
            <i className="material-icons icon-action icon-buttons-user">delete</i>
            Eliminar
          </button>
          <p className="error-login">{error}</p>
        </div>
      </div>
    </div>
  );
};

export default SurveyFeed;